
import { useState, useCallback } from 'react';

export default () => {
  const [defaultSystem, setDefaultSystem] = useState({});
  const setSystem = useCallback((system) => setDefaultSystem(system), []);
  return { defaultSystem, setSystem };
};